<template>
  <!-- 用工合规预警：合同签订合规 / 未签合同已发薪 / 长期服务用工 / 社保补缴风险 -->
  <riskWarn domain="labor" pageTitle="用工合规预警" themeColor="#7C5CFF"
    :subTabs="['合同签订合规', '未签合同已发薪', '长期服务用工', '社保补缴风险', '投保预警']" :showAmount="true" />
</template>

<script>
import riskWarn from './riskWarn'
export default {
  name: 'laborCompliance',
  components: { riskWarn }
}
</script>
